export default "__VITE_ASSET__CqpaP8gR__"